export const ELIGIBILITY_REQUEST_ALERTS = {
    DEDUCTIBLE: 'Deductible',
    HIGH_DEDUCTIBLE: 'High Deductible',
    MISMATCH: 'Mismatch',
    OTHER_PAYERS_EXIST: 'Other Payers Exist',
    OTHER_PRIMARY_PAYER: 'Other Primary Payer',
    MIXED_COVERAGE: 'Mixed Coverage',
};
